export default {
  PARTNER_REDIRECT: 'partner_redirect',
  IN_APP: 'in_app',
  B2C: 'b2c',
  WL: 'wl',
};
